import { GroupByPipe } from './../common/pipes/group-by.pipe';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders } from '@angular/core';

import { CommonService } from './services/common.service';
import { MessageService } from './services/message.service';
import { DataShareService } from './services/data.service';
import { SharedComponentConstants } from './shared-module.constants';
import { AppCommonModule } from './../common/app-common.module';
import { CarouselModule, CollapseModule, TabsModule, ModalModule, BsDropdownModule } from 'ngx-bootstrap';
import { CacheService } from './services/cache.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectizeModule } from 'ng-selectize';
import { StoreService } from '../shared/services/store.service';
import { AvatarModule } from 'ng2-avatar';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { MemberDisplayPriceConfigService } from './services/member-display-price-config.service';

@NgModule({
  imports: [
    AppCommonModule,
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    AvatarModule.forRoot(),
    BrowserAnimationsModule,
    SimpleNotificationsModule.forRoot({
      position: ['top', 'right'],
      lastOnBottom: true,
      preventLastDuplicates: true
    }),
    NgSelectizeModule,
    AngularMultiSelectModule,
  ],
  declarations: SharedComponentConstants.MODULE_COMPONENTS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    CommonService, MessageService, DataShareService, CacheService, MemberDisplayPriceConfigService, GroupByPipe
  ],
  exports: SharedComponentConstants.MODULE_COMPONENTS
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [StoreService]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts